import SelectorEngine from '../../utils/dom/selector-engine';
import EventHandler from '../../utils/dom/event-handler';
import FormComponent from '../FormComponent';
import InputField from '../InputField';

class CoachSearch extends FormComponent {
	constructor(element, config) {
		super(element, config);
	}
	markup(value, rowData, titleMarkup) {
		return `
            <div class="lta-coach-search">
				<div class="lta-coach-search-title u-hidden">${titleMarkup}</div>
                <div class="lta-coach-search--address-form u-mb-2">
                    <div class="lta-coach-search--first-name u-mb-3"></div>
                    <div class="lta-coach-search--last-name u-mb-3"></div>
                </div>
            </div>
        `;
	}
	afterRender() {
		this.coachSearchElement = SelectorEngine.findOne('.lta-coach-search', this.containerEl);
		this.coachSearchForm = SelectorEngine.findOne('.lta-coach-search--address-form', this.coachSearchElement);
		this.coachFirstName = SelectorEngine.findOne('.lta-coach-search--first-name', this.coachSearchForm);
		this.coachLastName = SelectorEngine.findOne('.lta-coach-search--last-name', this.coachSearchForm);

		const addressObjects = [
			{
				inputElementData: this.coachFirstName,
				elementDataKey: 'coachFirstName'
			},
			{
				inputElementData: this.coachLastName,
				elementDataKey: 'coachLastName'
			}
		];
		this.initInputObject(addressObjects);
	}
	initInputObject(addressObjects) {
		this.inputElementsObjects = [];
		for (const addressObject of addressObjects) {
			const inputFieldObject = new InputField(addressObject.inputElementData, {
				data: this.data[addressObject.elementDataKey]
			});
			this.inputElementsObjects.push(inputFieldObject);
			inputFieldObject.onChange((dataObject) => {
				const valueObject = {};
				valueObject[addressObject.elementDataKey] = dataObject.value;
				this.value = {
					...this.value,
					...valueObject
				};
			});
		}
	}
	validate() {
		for (const inputElementsObject of this.inputElementsObjects) {
			inputElementsObject.validate();
		}
	}
}
export default CoachSearch;
